<template>
    <v-app class="registration-form-wrapper" >

        <template v-if="!show_event_deleted_layout">
            <transition name="fade">
                <v-parallax
                        v-show="!page_loading"
                        id="event_background"
                        :src="getEventCover"
                        height="100%"
                        jumbotron
                >
                    <v-content>
                        <v-container class="page" fluid fill-height>
                            <v-layout align-center justify-center>
                                <v-flex xs12 sm10 md8 lg8>

                                    <v-card class="mb-2">
                                        <v-img
                                                :src="getEventCover"
                                                gradient="to top, rgba(0,0,0,.8) 0, rgba(0,0,0,.6) 5%, rgba(0,0,0,0) 40%"                                    height="300px"
                                        >
                                            <v-layout
                                                    column
                                                    fill-height
                                            >
                                                <v-card-title class="justify-end">
                                                    <v-btn
                                                            v-if="currentLanguage === 'en'"
                                                            color="blue darken-2"
                                                            dark
                                                            small
                                                            class="text-capitalize lang-btn"
                                                            @click="changeLanguage('tc')"
                                                    >
                                                        中文
                                                    </v-btn>
                                                    <v-btn
                                                            v-else-if="currentLanguage === 'tc'"
                                                            color="blue darken-2"
                                                            dark
                                                            small
                                                            class="text-capitalize lang-btn"
                                                            @click="changeLanguage('en')"
                                                    >
                                                        En
                                                    </v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-dialog
                                                            v-model="dialog"
                                                            width="500"
                                                    >
                                                        <v-card>
                                                            <v-card-title
                                                                    class="headline blue darken-2 white--text"
                                                                    primary-title
                                                            >
                                                                {{ $t('registration.share_this_event') }}
                                                            </v-card-title>

                                                            <v-card-text>
                                                                <!--                                                            <v-flex xs12 class="pb-0">-->
                                                                <!--                                                                <v-text-field-->
                                                                <!--                                                                        label="Registration Url"-->
                                                                <!--                                                                        class="text-field-without-message"-->
                                                                <!--                                                                        v-model="registration_url"-->
                                                                <!--                                                                        outline-->
                                                                <!--                                                                        readonly-->
                                                                <!--                                                                >-->
                                                                <!--                                                                    <v-tooltip slot="append" bottom>-->
                                                                <!--                                                                        <v-icon slot="activator" @click="copyUrl">fa-copy fa-fw</v-icon>-->
                                                                <!--                                                                        <span>{{$t('action.copy')}}</span>-->
                                                                <!--                                                                    </v-tooltip>-->
                                                                <!--                                                                </v-text-field>-->
                                                                <!--                                                            </v-flex>-->
                                                                <v-flex xs12>
                                                                    <div>{{$t('event.msg_share_registration_url')}}:</div>
                                                                    <div>

                                                                        <v-btn class="ml-0 mr-1 text-capitalize" color="primary" dark @click="copyUrl()">
                                                                            <v-icon>fa fa-copy</v-icon>&nbsp;
                                                                            {{$t('action.copy')}}
                                                                        </v-btn>
                                                                        <v-btn class="ml-0 mr-1 text-capitalize" color="green" dark @click="shareWithWhatsapp()">
                                                                            <v-icon>fab fa-whatsapp</v-icon>&nbsp;
                                                                            Whatsapp
                                                                        </v-btn>
                                                                        <v-btn class="ml-0 mr-1 text-capitalize" color="indigo" dark target="_blank" @click="shareWithFacebook()">
                                                                            <v-icon>fab fa-facebook-f</v-icon>&nbsp;
                                                                            Facebook
                                                                        </v-btn>
                                                                    </div>
                                                                </v-flex>
                                                            </v-card-text>



                                                            <v-divider></v-divider>

                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                        color="primary"
                                                                        flat
                                                                        @click="dialog = false"
                                                                >
                                                                    {{ $t('action.close') }}
                                                                </v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                    <v-btn
                                                            v-if="!event_data.is_private"
                                                            @click="shareEvent"
                                                            color="blue darken-2"
                                                            dark
                                                            small
                                                            class="text-capitalize"
                                                    >
                                                        {{ $t('action.share') }}
                                                    </v-btn>
                                                    <v-menu
                                                            bottom
                                                            origin="center center"
                                                            transition="scale-transition"
                                                    >
                                                        <v-btn
                                                                v-if="!event_data.is_private"
                                                                slot="activator"
                                                                color="blue darken-2"
                                                                dark
                                                                small
                                                                class="text-capitalize"
                                                        >
                                                            {{ $t('registration.add_to_calendar') }}
                                                        </v-btn>
                                                        <v-list>
                                                            <v-list-tile
                                                                    @click="addToGoogleCalendar()"
                                                            >
                                                                <v-list-tile-avatar>
                                                                    <v-icon color="blue">fab fa-google</v-icon>
                                                                </v-list-tile-avatar>
                                                                <v-list-tile-title>{{$t('calendar_app.google_calendar')}}</v-list-tile-title>
                                                            </v-list-tile>
                                                        </v-list>
                                                    </v-menu>
                                                </v-card-title>
                                                <v-spacer></v-spacer>

                                                <v-card-title class="white--text">
                                                    <div class="display-1 pl-2 pb-2">{{event_data.title}}</div>
                                                </v-card-title>

                                                <div class="cover-copy-right-wp">{{$t('app.copy_right')}} {{$t('app.company_name')}}</div>
                                            </v-layout>
                                        </v-img>

                                        <!--<v-card-text class="pa-0">-->
                                        <!--123456-->
                                        <!--</v-card-text>-->

                                        <v-card-text class="pa-0">

                                            <v-alert
                                                    :value="!event_data.is_registrable"
                                                    type="info"
                                                    class="mt-0"
                                            >
                                                {{$t('event.msg_event_enrollment_close')}}
                                            </v-alert>

                                            <v-list class="pa-0">


                                                <v-list-tile class="align-start full-height">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">event</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content>
                                                        <v-list-tile-title class="event-time-text">
                                                            {{getEventPeriod}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>

                                                </v-list-tile>

                                                <v-divider></v-divider>

                                                <v-list-tile class="align-start full-height">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">location_on</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content>
                                                        <v-list-tile-title class="address-text">{{event_data.location_text?event_data.location_text:$t('registration.location_tbc')}}</v-list-tile-title>
                                                    </v-list-tile-content>

                                                </v-list-tile>

                                                <v-divider></v-divider>

                                                <v-list-tile v-if="show_payment_related">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">attach_money</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{utils.toCurrencyFormat(event_data.price_per_head)}}</v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-divider v-if="show_payment_related" />

                                                <!--                                            <v-list-tile v-if="event_data.display_attendee_count == 1">-->
                                                <!--                                                <v-list-tile-action>-->
                                                <!--                                                    <v-icon color="indigo">how_to_reg</v-icon>-->
                                                <!--                                                </v-list-tile-action>-->

                                                <!--                                                <v-list-tile-content>-->
                                                <!--                                                    <div class="event-info-text py-2">-->
                                                <!--                                                        <span class="event-stat-span" v-if="event_data.display_attendee_count">{{$t('registration.num_of_attendees', {'num': event_data.attendee_count})}}</span>-->
                                                <!--                                                    </div>-->
                                                <!--                                                </v-list-tile-content>-->
                                                <!--                                            </v-list-tile>-->

                                                <!--                                            <v-divider v-if="event_data.display_attendee_count == 1"></v-divider>-->

                                                <v-list-tile v-if="event_data.display_registrants == 1">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">assignment_turned_in</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content>
                                                        <div class="event-info-text py-2">
                                                            <span class="event-stat-span">{{event_data.registrants.length}} ({{event_data.attendee_count}})<v-btn small color="primary" @click="registrant_list_dialog.show = true">{{$t('action.view')}}</v-btn></span>
                                                        </div>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-divider v-if="event_data.display_registrants == 1"></v-divider>

                                                <v-list-tile v-if="event_data.event_photos.length" class="align-start full-height">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">image</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content :class="$vuetify.breakpoint.smAndDown ? 'content-scrollable' : '' ">
                                                        <v-layout :row="!$vuetify.breakpoint.smAndDown" :wrap="!$vuetify.breakpoint.smAndDown">
                                                            <template v-for="event_image in event_data.event_photos">
                                                                <v-card flat tile class="d-flex pa-1">
                                                                    <v-img
                                                                            height="100px"
                                                                            width="100px"
                                                                            :src="event_image.file.absolute_url"
                                                                            aspect-ratio="1"
                                                                            class="grey lighten-2 event-image-grid"
                                                                            @click="showImgLightBox(event_image.file.absolute_url, event_image.description)"
                                                                    ></v-img>
                                                                </v-card>
                                                            </template>

                                                        </v-layout>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-divider v-if="event_data.event_photos.length"></v-divider>

                                                <v-list-tile v-if="event_data.event_attachments.length">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">attach_file</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            <a @click="event_attachment_dialog.show = true"><span>{{$t('event.num_of_event_attachment', {'number': event_data.event_attachments.length})}}</span></a>
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>

                                                </v-list-tile>

                                                <v-divider v-if="event_data.event_attachments.length"></v-divider>

                                                <v-list-tile v-if="event_data.media && event_data.media.length">
                                                    <v-list-tile-action>
                                                        <v-icon color="indigo">perm_media</v-icon>
                                                    </v-list-tile-action>

                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            <a @click="event_media_dialog.show = true"><span>{{$t('event.num_of_event_media', {'number': event_data.media.length})}}</span></a>
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-divider v-if="event_data.media && event_data.media.length"></v-divider>

                                                <v-list-tile class="align-start full-height" v-if="event_data.description">
<!--                                                    <v-list-tile-action>-->
<!--                                                        <v-icon color="indigo">info</v-icon>-->
<!--                                                    </v-list-tile-action>-->

                                                    <v-list-tile-content class="event-description-wrapper">
                                                        <div class="event-info-text py-2" v-html="event_data.description"></div>
                                                    </v-list-tile-content>

                                                </v-list-tile>

                                                <v-divider v-if="event_data.description"></v-divider>

                                            </v-list>
                                        </v-card-text>


                                        <!--<v-card-text v-if="show_registration_btn" class="py-1">-->
                                        <!--<v-btn color="success" block @click="show_registration_form = true, show_registration_btn = false">-->
                                        <!--{{ $t('action.registration') }}-->
                                        <!--</v-btn>-->
                                        <!--</v-card-text>-->

                                        <v-card-text v-show="show_registration_form && event_data.is_registrable">
                                            <v-form id="registration_form" method="post" :action="form_action" v-on:success="registrationSuccess" ref="registration_form">

                                                <input type="hidden" name="event_id" v-model="event_data.encrypted_id">
                                                <input type="hidden" name="activity" v-model="form_inputs.activity">
                                                <input type="hidden" name="attend_status" v-model="form_inputs.attend_status">
                                                <input type="hidden" name="t" v-model="form_inputs.token">
                                                <input type="hidden" name="selected_contact" v-model="form_inputs.selected_contact">
                                                <input type="hidden" name="payment_method" v-model="form_inputs.payment_method">
                                                <input type="hidden" name="payment_receipt_file_id" v-model="form_inputs.payment_receipt_file_id">

                                                <v-alert
                                                        :value="errors.general!==''"
                                                        type="error"
                                                >
                                                    {{errors.general}}
                                                </v-alert>

                                                <v-alert
                                                        :value="isEventFull"
                                                        type="info"
                                                >
                                                    {{$t('event.msg_event_full')}}
                                                </v-alert>

                                                <v-card v-show="!isEventFull" class="elevation-0">
                                                    <v-card-text class="pa-2">

                                                        <div class="layout column">
                                                            <!--<img src="/static/m.png" alt="Vue Material Admin" width="120" height="120">-->
                                                            <h1 class="flex my-4 primary--text">{{event_data.is_private ? $t('event.invitation') : $t("action.registration")}}</h1>
                                                        </div>

                                                        <v-container grid-list-lg pa-0 ma-0>

                                                            <v-layout row wrap v-if="event_data.allow_retrieve_registration">
                                                                <v-flex xs12>
                                                                    <v-btn color="primary" class="ma-0" @click="retrieve_registration_dialog.show = true"><v-icon>search</v-icon> Retrieve my registration</v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap>
                                                                <v-flex xs12 v-if="event_data.ask_for_attend">
                                                                    <v-btn-toggle mandatory v-model="attend_status_index">
                                                                        <v-btn v-on:click="setAttendStatus(1)" color="success" class="white--text">{{$t('action.attend')}}</v-btn>
                                                                        <v-btn v-on:click="setAttendStatus(7)" color="primary" class="white--text">{{$t('action.maybe')}}</v-btn>
                                                                        <v-btn v-on:click="setAttendStatus(8)" color="error" class="white--text">{{$t('action.excuse')}}</v-btn>
                                                                    </v-btn-toggle>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm6 v-if="event_data.enable_select_name_from_invitations && event_data.contact_select_list.length">
                                                                    <v-autocomplete
                                                                            :items="event_data.contact_select_list"
                                                                            v-model="selected_contact_info"
                                                                            :label="$t('registration.select_name_from_list')"
                                                                            item-text="search_field"
                                                                            clearable
                                                                            return-object
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            <v-list-tile-content>
                                                                                <v-list-tile-title v-text="data.item.name + ' (' + data.item.areaCode + ' ' + data.item.phone + ')'"></v-list-tile-title>
                                                                            </v-list-tile-content>
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            <template>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-title v-text="data.item.name"></v-list-tile-title>
                                                                                    <v-list-tile-sub-title v-text="data.item.areaCode + ' ' + data.item.phone"></v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </template>
                                                                        </template>
                                                                    </v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap v-show="!selected_contact_info">
                                                                <v-flex xs4 sm2>
                                                                    <v-text-field
                                                                            type="tel"
                                                                            name="area_code"
                                                                            prefix="+"
                                                                            v-model="form_inputs.area_code"
                                                                            :error-messages="errors.area_code"
                                                                            :label="$t('contact.area_code')"
                                                                            :rules="[form_rules.required]"
                                                                            :readonly="event_data.is_private === 1"
                                                                            :loading="phone_searching"
                                                                            :disabled="phone_searching"
                                                                            mask="###"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                                <v-flex xs8 sm4>
                                                                    <v-text-field
                                                                            type="tel"
                                                                            append-icon="phone"
                                                                            name="contact_phone"
                                                                            v-model="form_inputs.contact_phone"
                                                                            :error-messages="errors.contact_phone"
                                                                            :label="$t('registration.contact_phone')"
                                                                            :rules="[form_rules.required]"
                                                                            :readonly="event_data.is_private === 1"
                                                                            v-on:input="searchInvitedContact"
                                                                            :loading="phone_searching"
                                                                            :disabled="phone_searching"
                                                                            :hint="getPhoneHintText"
                                                                            :mask="phoneMask"
                                                                            ref="contact_phone"
                                                                            persistent-hint
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs12 sm6>
                                                                    <v-text-field
                                                                            append-icon="person"
                                                                            name="full_name"
                                                                            :error-messages="errors.full_name"
                                                                            v-model="form_inputs.full_name"
                                                                            :label="$t('registration.your_name')"
                                                                            :rules="[form_rules.required]"
                                                                            :readonly="event_data.is_private === 1"
                                                                            :disabled="phone_invited"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm6 v-if="event_data.enable_custom_field">
                                                                    <v-text-field
                                                                            type="text"
                                                                            class="pt-0"
                                                                            name="custom_field_value"
                                                                            v-model="form_inputs.custom_field_value"
                                                                            :label="event_data.custom_field_label"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                                <v-flex xs12 sm6 v-if="event_data.enable_custom_field_2">
                                                                    <v-text-field
                                                                            type="text"
                                                                            class="pt-0"
                                                                            name="custom_field_value_2"
                                                                            v-model="form_inputs.custom_field_value_2"
                                                                            :label="event_data.custom_field_label_2"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                                <v-flex xs12 sm6 v-if="event_data.enable_custom_field_3">
                                                                    <v-text-field
                                                                            type="text"
                                                                            class="pt-0"
                                                                            name="custom_field_value_3"
                                                                            v-model="form_inputs.custom_field_value_3"
                                                                            :label="event_data.custom_field_label_3"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                        v-if="!event_data.is_private || accept"
                                                                        v-show="showGuestSection"
                                                                        xs12
                                                                        sm6
                                                                >
                                                                    <v-select
                                                                            :items="getGuestNumberItems"
                                                                            :label="$t('registration.total_guest_number')"
                                                                            :error-messages="errors.total_guest_number"
                                                                            v-model="form_inputs.total_guest_number"
                                                                    ></v-select>
                                                                    <input type="hidden" name="total_guest_number" :value="form_inputs.total_guest_number" />
                                                                </v-flex>
                                                                <v-flex
                                                                        v-show="showGuestSection"
                                                                        sm12
                                                                        :style="(event_data.is_private) ? 'display: none;' : ''"
                                                                >
                                                                    <v-checkbox
                                                                            v-model="form_inputs.is_attendee"
                                                                            name="is_attendee"
                                                                            class="mt-0"
                                                                            color="indigo"
                                                                            :label="$t('registration.part_of_attendee')"
                                                                            value="1"
                                                                            hide-details
                                                                    ></v-checkbox>
                                                                </v-flex>

                                                                <v-flex
                                                                        v-if="hasActivity && form_inputs.attend_status == 1"
                                                                        sm12>
                                                                    <h3>{{$t('registration.select_an_activity')}}</h3>
                                                                    <div v-if="event_data.activity_multiple">
                                                                        <template v-for="(activity_item) in event_data.activities">
                                                                            <v-checkbox
                                                                                    v-model="form_inputs.activity"
                                                                                    class="mt-0 mb-3 activity-checkbox-item"
                                                                                    color="indigo"
                                                                                    :label="activity_item.name"
                                                                                    :value="activity_item.id"
                                                                                    hide-details
                                                                            ></v-checkbox>
                                                                        </template>
                                                                    </div>
                                                                    <v-radio-group
                                                                            v-else
                                                                            v-model="form_inputs.activity"
                                                                            :error-messages="errors.activity"
                                                                            row
                                                                    >
                                                                        <template v-for="(activity_item) in event_data.activities">
                                                                            <v-radio :label="activity_item.name" :value="activity_item.id" color="primary"></v-radio>
                                                                        </template>
                                                                    </v-radio-group>
                                                                    <v-input :error-messages="errors.activity" />
                                                                </v-flex>

                                                                <v-flex v-if="show_payment_related && event_data.enable_submit_payment && form_inputs.attend_status == 1" xs12 ref="payment_receipt">
                                                                    <h3>{{$t('deposit_transaction.payment_method')}}</h3>
                                                                    <v-radio-group
                                                                            v-model="form_inputs.payment_method"
                                                                            :error-messages="errors.payment_method"
                                                                            row
                                                                    >
                                                                        <v-radio class="mb-3" :label="$t('registration.pay_later')" color="primary" value="0"></v-radio>
                                                                        <template v-for="payment_method in payment_methods">
                                                                            <v-radio class="mb-3" :label="$t('payment_methods.' + payment_method)" :value="payment_method" color="primary"></v-radio>
                                                                        </template>
                                                                    </v-radio-group>

                                                                    <template v-if="form_inputs.payment_method > 0">
                                                                        <v-text-field
                                                                                type="text"
                                                                                class="pt-0"
                                                                                name="payment_ref"
                                                                                v-model="form_inputs.payment_reference"
                                                                                :label="$t('deposit_transaction.payment_ref')"
                                                                        ></v-text-field>

                                                                        <h3>{{$t('registration.upload_payment_receipt')}}</h3>
                                                                        <v-card v-if="payment_receipt_file" class="elevation-0">
                                                                            <v-img
                                                                                    :src="payment_receipt_file.absolute_url"
                                                                                    aspect-ratio="2"
                                                                                    class="lighten-2 elevation-1"
                                                                                    style="max-width: 200px"
                                                                                    contain
                                                                                    @click="showImgLightBox(payment_receipt_file.absolute_url)"
                                                                            ></v-img>
                                                                            <v-btn small color="error" class="ml-0" @click="remove_payment_receipt_file">{{$t('action.remove')}}</v-btn>
                                                                        </v-card>
                                                                        <v-card v-else class="upload-image-wp elevation-0 text-xs-center" @click="show_upload_receipt_dialog" v-bind:style="hover_image_upload ? 'border: 3px dashed #AAA' : 'border: 3px dashed #DDD'" @mouseover="hover_image_upload = true" @mouseleave="hover_image_upload = false">
                                                                            <v-card-title class="justify-center pb-0">
                                                                                <v-icon size="40">fas fa-cloud-upload-alt</v-icon>
                                                                            </v-card-title>
                                                                            <v-card-text>
                                                                                {{$t('registration.msg_upload_payment_receipt')}}
                                                                            </v-card-text>
                                                                        </v-card>

                                                                        <v-input :error-messages="errors.payment_receipt"></v-input>
                                                                    </template>

                                                                </v-flex>
                                                            </v-layout>

                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-text
                                                            v-if="(!event_data.is_private || accept) && form_inputs.total_guest_number > 0"
                                                            v-show="showGuestSection"
                                                            pa-2
                                                    >

                                                        <div class="layout column">
                                                            <h1 class="flex my-4 primary--text">{{ $t("registration.guest_details") }}</h1>
                                                        </div>

                                                        <v-container grid-list-lg pa-0>
                                                            <template v-for="(i,index) in form_inputs.total_guest_number">
                                                                <v-layout :key="index" row wrap>
                                                                    <v-flex xs4 sm2>
                                                                        <v-text-field
                                                                                prefix="+"
                                                                                v-model="guest_details.guest_area_code[index]"
                                                                                :label="$t('contact.area_code')"
                                                                                :error-messages="errors['guest_area_code_' + index]"
                                                                                :name="'guest_area_code[' + index + ']'"
                                                                                :ref="'guest_area_code_' + index"
                                                                                :disabled="form_inputs.is_attendee && index === 0"
                                                                                mask="###"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs8 sm4>
                                                                        <v-text-field
                                                                                append-icon="phone"
                                                                                v-model="guest_details.guest_contact_phone[index]"
                                                                                :label="$t('registration.contact_phone')"
                                                                                :error-messages="errors['guest_contact_phone_' + index]"
                                                                                :name="'guest_contact_phone[' + index + ']'"
                                                                                :ref="'guest_contact_phone_' + index"
                                                                                :disabled="form_inputs.is_attendee && index === 0"
                                                                                :mask="phoneMask"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6>
                                                                        <v-text-field
                                                                                append-icon="person"
                                                                                v-model="guest_details.guest_name[index]"
                                                                                :label="$t('registration.guest_name')"
                                                                                :error-messages="errors['guest_name_' + index]"
                                                                                :name="'guest_name[' + index + ']'"
                                                                                :ref="'guest_name_' + index"
                                                                                :disabled="form_inputs.is_attendee && index === 0"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </template>

                                                        </v-container>

                                                    </v-card-text>

                                                    <v-card-actions v-if="show_action_buttons">
                                                        <template v-if="event_data.is_private && !accept">
                                                            <v-btn
                                                                    block
                                                                    dark
                                                                    color="red"
                                                                    ref="declineBtn"
                                                                    @click="declineInvitation"
                                                                    type="button"
                                                            >{{$t('registration.decline')}}</v-btn>
                                                            <v-btn
                                                                    block
                                                                    color="primary"
                                                                    ref="acceptBtn"
                                                                    @click="accept = true"
                                                            >{{$t('registration.next_step')}}</v-btn>
                                                        </template>
                                                        <template v-else>
                                                            <v-btn
                                                                    block
                                                                    color="primary"
                                                                    type="submit"
                                                                    ref="submit"
                                                                    :loading="form.loading"
                                                            >{{submit_button_text}}</v-btn>
                                                            <v-btn
                                                                    v-if="show_cancel_btn"
                                                                    block
                                                                    color="error"
                                                                    type="button"
                                                                    @click="cancelRegistration"
                                                            >{{$t('registration.cancel_registration')}}</v-btn>
                                                            <!--                                                        <v-btn-->
                                                            <!--                                                                block-->
                                                            <!--                                                                color="primary"-->
                                                            <!--                                                                type="submit"-->
                                                            <!--                                                                ref="submit"-->
                                                            <!--                                                                :disabled="Boolean(event_data.allow_invited_contact_only) && !phone_accept"-->
                                                            <!--                                                        >{{$t('form.register')}}</v-btn>-->
                                                        </template>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-form>
                                        </v-card-text>

                                        <v-card-text v-show="show_registration_success">

                                            <v-card class="elevation-0 text-xs-center">
                                                <v-card-text class="py-0 pt-2">
                                                    <v-icon size="64" color="green">fa-check</v-icon>
                                                </v-card-text>
                                                <v-card-text color="green" class="py-2">
                                                    <h3 class="notification-header green--text">{{$t('general.success')}}</h3>
                                                </v-card-text>
                                                <v-card-text>
                                                    {{$t('registration.msg_registration_success')}}
                                                </v-card-text>
                                                <v-card-text class="title">
                                                    {{$t('event.registration_details')}}:
                                                </v-card-text>
                                                <v-card-text>
                                                    <table class="details-table">
                                                        <tbody>
                                                        <tr>
                                                            <th>{{$t('registration.your_name')}}:</th>
                                                            <td>{{form_inputs.full_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{$t('registration.contact_phone')}}:</th>
                                                            <td>+{{form_inputs.area_code}}-{{form_inputs.contact_phone}}</td>
                                                        </tr>
                                                        <tr v-if="showGuestSection">
                                                            <th>{{$t('registration.total_guest_number')}}:</th>
                                                            <td>{{form_inputs.total_guest_number}}</td>
                                                        </tr>
                                                        <tr v-if="form_inputs.activity.length">
                                                            <th>{{$t('registration.activity')}}:</th>
                                                            <td>{{getActivityNamesByIds(form_inputs.activity).join(', ')}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </v-card-text>

                                                <v-card-text>
                                                    <v-btn
                                                            block
                                                            color="primary"
                                                            @click="refreshPage"
                                                    >{{$t('action.back')}}</v-btn>
                                                </v-card-text>

                                            </v-card>

                                        </v-card-text>

                                        <v-card-text v-show="show_cancel_success">

                                            <v-card class="elevation-0 text-xs-center">
                                                <v-card-text class="py-0 pt-2">
                                                    <v-icon size="64" color="red">fa-times</v-icon>
                                                </v-card-text>
                                                <v-card-text color="green" class="py-2">
                                                    <h3 class="notification-header red--text">{{$t('registration.cancel')}}</h3>
                                                </v-card-text>
                                                <v-card-text>
                                                    {{$t('registration.msg_cancel_success')}}
                                                </v-card-text>
                                                <v-card-text class="title">
                                                    {{$t('event.registration_details')}}:
                                                </v-card-text>
                                                <v-card-text>
                                                    <table class="details-table">
                                                        <tbody>
                                                        <tr>
                                                            <th>{{$t('registration.your_name')}}:</th>
                                                            <td>{{form_inputs.full_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{$t('registration.contact_phone')}}:</th>
                                                            <td>+{{form_inputs.area_code}}-{{form_inputs.contact_phone}}</td>
                                                        </tr>
                                                        <tr v-if="showGuestSection">
                                                            <th>{{$t('registration.total_guest_number')}}:</th>
                                                            <td>{{form_inputs.total_guest_number}}</td>
                                                        </tr>
                                                        <tr v-if="form_inputs.activity.length">
                                                            <th>{{$t('registration.activity')}}:</th>
                                                            <td>{{getActivityNamesByIds(form_inputs.activity).join(', ')}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </v-card-text>

                                                <v-card-text>
                                                    <v-btn
                                                            block
                                                            color="primary"
                                                            @click="refreshPage"
                                                    >{{$t('action.back')}}</v-btn>
                                                </v-card-text>

                                            </v-card>

                                        </v-card-text>

                                        <v-card-text v-show="show_invitation_declined">

                                            <v-card class="elevation-0 text-lg-center">
                                                <v-card-text class="py-0 pt-2">
                                                    <v-icon size="64" color="red">fa-times</v-icon>
                                                </v-card-text>
                                                <v-card-text class="py-2">
                                                    <h3 class="notification-header red--text">{{$t('registration.declined')}}</h3>
                                                </v-card-text>
                                                <v-card-text>
                                                    <p>{{$t('registration.see_you_next_time')}}</p>
                                                </v-card-text>
                                            </v-card>

                                        </v-card-text>
                                    </v-card>

                                    <v-card>
                                        <v-card-text class="text-xs-center">
                                            <div class="promotion-message-wrapper">
                                                <a :href="sign_up_page_url" target="_blank">{{$t('login.msg_signup_promotion')}}</a>
                                            </div>
                                        </v-card-text>
                                    </v-card>

                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-content>

                    <v-dialog v-model="registrant_list_dialog.show" scrollable max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
                        <v-card>
                            <!--                        <v-card-title-->
                            <!--                            class="headline blue darken-2 white&#45;&#45;text"-->
                            <!--                            primary-title-->
                            <!--                            v-if="event_data.registrants"-->
                            <!--                        >-->
                            <!--                            {{$t('registration.registrant_list')}}-->
                            <!--                        </v-card-title>-->
                            <v-toolbar card dark color="primary">
                                <v-toolbar-title>{{$t('registration.registrant_list')}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>

                                <h2>{{event_data.title}} - {{event_data.start_timestamp | moment("LLLL")}}</h2>
                                <h3>{{get_event_location}}</h3>

                                <hr class="dialog-sep">

                                <h3>{{$t('registration.num_of_registrants', {'num': event_data.registrants.length})}} | {{$t('registration.num_of_attendees', {'num': event_data.attendee_count})}}</h3>

                                <v-list two-line>
                                    <template v-for="(item, index) in event_data.registrants">
                                        <v-list-tile
                                                class="registrants-list-item"
                                                avatar
                                                @click=""
                                        >
                                            <v-list-tile-avatar>
                                                <v-icon class="grey lighten-1 white--text">person</v-icon>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{item.name}} <span v-if="(item.attendee_count > 1)">({{item.attendee_count}})</span></v-list-tile-title>
                                                <div class="attendee-wrapper"><b>{{$t('event.attendee')}}</b>: {{getRegistrationAttendeeText(item)}}</div>
                                                <div class="activity-wrapper" v-if="getActivityNamesByIds(item.activities).length && (event_data.display_selected_activity || registrant_list_dialog.show_details)"><b>{{$t('event.activity')}}</b>: {{getActivityNamesByIds(item.activities).join(', ')}}</div>
                                            </v-list-tile-content>
                                            <v-list-tile-action v-if="(event_data.display_payment_status || (registrant_list_dialog.show_details && show_payment_related)) && item.payment_status != null">
                                                <v-list-tile-action-text>{{$t('payment_status.' + item.payment_status)}}</v-list-tile-action-text>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>

                                <div v-if="event_data.maybe_registrants.length">
                                    <h3>{{$t('registration.num_of_maybe', {'num': event_data.maybe_registrants.length})}}</h3>
                                    <v-list two-line>
                                        <template v-for="(item, index) in event_data.maybe_registrants">
                                            <v-list-tile
                                                    avatar
                                                    @click=""
                                            >
                                                <v-list-tile-avatar>
                                                    <v-icon class="grey lighten-1 white--text">person</v-icon>
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{item.name}} <span v-if="(item.attendee_count > 1)">({{item.attendee_count}})</span></v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </div>

                                <div v-if="event_data.excused_registrants.length">
                                    <h3>{{$t('registration.num_of_excused', {'num': event_data.excused_registrants.length})}}</h3>
                                    <v-list two-line>
                                        <template v-for="(item, index) in event_data.excused_registrants">
                                            <v-list-tile
                                                    avatar
                                                    @click=""
                                            >
                                                <v-list-tile-avatar>
                                                    <v-icon class="grey lighten-1 white--text">person</v-icon>
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{item.name}} <span v-if="(item.attendee_count > 1)">({{item.attendee_count}})</span></v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </div>

                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="blue darken-1"
                                        flat="flat"
                                        @click="exportRegistrantsList()"
                                >
                                    <v-icon>fab fa-whatsapp</v-icon>
                                    &nbsp;{{$t('action.share')}}
                                </v-btn>
                                <v-btn
                                        color="blue darken-1"
                                        flat="flat"
                                        @click="registrant_list_dialog.show = false; registrant_list_dialog.show_details = false"
                                >
                                    {{$t('action.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="event_attachment_dialog.show"  scrollable max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
                        <v-card>
                            <v-card-title
                                    class="headline blue darken-2 white--text"
                                    primary-title
                            >
                                {{$t('event.event_attachments')}}
                            </v-card-title>
                            <v-card-text>
                                <v-list two-line>
                                    <template v-if="event_data.event_attachments.length" v-for="event_attachment in event_data.event_attachments">
                                        <v-list-tile
                                                avatar>
                                            <v-list-tile-avatar>
                                                <v-icon>{{getFileIconByName(event_attachment.file.filename)}}</v-icon>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title v-text="event_attachment.file.filename"></v-list-tile-title>
                                                <v-list-tile-sub-title :title="event_attachment.description" v-text="event_attachment.description"></v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <a :href="event_attachment.file.absolute_url" target="_blank" class="download-button">
                                                    <v-btn icon>
                                                        <v-icon>cloud_download</v-icon>
                                                    </v-btn>
                                                </a>
                                                <!--                                            <v-btn-->
                                                <!--                                                    @click="fileDownload(event_attachment.file.absolute_url, event_attachment.file.filename)"-->
                                                <!--                                                    slot="activator"-->
                                                <!--                                                    icon>-->
                                                <!--                                                <v-icon>cloud_download</v-icon>-->
                                                <!--                                            </v-btn>-->
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="blue darken-1"
                                        flat="flat"
                                        @click="event_attachment_dialog.show = false"
                                >
                                    {{$t('action.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="event_media_dialog.show"  scrollable max-width="800px" :fullscreen="$vuetify.breakpoint.smAndDown">
                        <v-card>
                            <v-card-title
                                    class="headline blue darken-2 white--text"
                                    primary-title
                            >
                                {{$t('event.media')}}
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-sm fluid>

                                    <v-layout row wrap>
                                        <v-flex xs12 pb-2>
                                            <v-btn-toggle v-model="media_list.filter_type" mandatory>
                                                <v-btn flat :value="0">
                                                    {{$t('app.all')}}
                                                </v-btn>
                                                <v-btn flat :value="mediaType.VR_IMAGE">
                                                    {{$t('media_type.vr_image')}}
                                                </v-btn>
                                                <v-btn flat :value="mediaType.NORMAL_IMAGE">
                                                    {{$t('media_type.normal_image')}}
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-flex>
                                        <template v-for="media_item in event_data.media">

                                            <v-flex
                                                    xs4
                                                    md3
                                                    d-flex
                                                    v-if="media_list.filter_type == 0 || media_item.type == media_list.filter_type"
                                            >


                                                <v-card>
                                                    <v-img
                                                            :src="getThumbnailUrl(media_item.file.absolute_url)"
                                                            height="150px"
                                                    >
                                                        <template v-if="media_item.type == mediaType.VR_IMAGE" v-slot:placeholder>
                                                            <v-layout
                                                                    fill-height
                                                                    align-center
                                                                    justify-center
                                                                    ma-0
                                                            >
                                                                <div class="image-360-icon"></div>
                                                            </v-layout>
                                                        </template>
                                                    </v-img>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn icon @click="display_media(media_item)">
                                                            <v-icon>visibility</v-icon>
                                                        </v-btn>
                                                        <v-btn icon @click="downloadFile(media_item.file.absolute_url)">
                                                            <v-icon>cloud_download</v-icon>
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>



                                                <!--                                            <v-card flat tile class="d-flex">-->
                                                <!--                                                <v-img-->
                                                <!--                                                        :src="getThumbnailUrl(media_item.file.absolute_url)"-->
                                                <!--                                                        aspect-ratio="1"-->
                                                <!--                                                        class="grey lighten-2"-->
                                                <!--                                                >-->
                                                <!--                                                    <template v-if="media_item.type == mediaType.VR_IMAGE" v-slot:placeholder>-->
                                                <!--                                                        <v-layout-->
                                                <!--                                                                fill-height-->
                                                <!--                                                                align-center-->
                                                <!--                                                                justify-center-->
                                                <!--                                                                ma-0-->
                                                <!--                                                        >-->
                                                <!--                                                            <div class="image-360-icon"></div>-->
                                                <!--                                                        </v-layout>-->
                                                <!--                                                    </template>-->
                                                <!--                                                </v-img>-->
                                                <!--                                            </v-card>-->
                                            </v-flex>
                                        </template>

                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="blue darken-1"
                                        flat="flat"
                                        @click="event_media_dialog.show = false"
                                >
                                    {{$t('action.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="retrieve_registration_dialog.show" scrollable max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
                        <v-card>
                            <v-card-title
                                    class="headline blue darken-2 white--text"
                                    primary-title
                            >
                                {{$t('registration.retrieve_my_registration')}}
                            </v-card-title>
                            <v-card-text class="v-dialog-body">
                                <v-container grid-list-lg pa-0>

                                    <v-layout row wrap v-if="retrieve_registration_dialog.error">
                                        <v-flex xs12>
                                            <v-alert
                                                    :value="true"
                                                    type="error"
                                            >
                                                {{retrieve_registration_dialog.error}}
                                            </v-alert>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row wrap>
                                        <v-flex xs3>
                                            <v-text-field
                                                    :label="$t('contact.area_code')"
                                                    prefix="+"
                                                    type="text"
                                                    v-model="retrieve_registration_dialog.area_code"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs9>
                                            <v-text-field
                                                    :label="$t('registration.contact_phone')"
                                                    type="text"
                                                    v-model="retrieve_registration_dialog.contact_phone"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="blue darken-1"
                                        flat="flat"
                                        @click="retrieveRegistration"
                                        :loading="retrieve_registration_dialog.loading"
                                >
                                    {{$t('action.retrieve')}}
                                </v-btn>
                                <v-btn
                                        color="blue darken-1"
                                        flat="flat"
                                        @click="closeRetrieveRegistrationDialog"
                                >
                                    {{$t('action.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <upload-dialog
                            v-model="uploadPaymentReceiptDialog.show"
                            :title="$t('upload.button')"
                            accept="image/*"
                            :maxSizeInMB="uploadPaymentReceiptDialog.maxSizeInMB"
                            :admin-upload="false"
                            :type="uploadPaymentReceiptDialog.type"
                            :multiple="uploadPaymentReceiptDialog.multiple"
                            ref="uploadPaymentReceiptDialog"
                            @success="uploadPaymentReceiptDialog.uploadSuccess"
                            :postFields="uploadPaymentReceiptDialog.postFields"
                    ></upload-dialog>

                </v-parallax>
            </transition>
            <transition name="fade">
                <v-layout full-height align-center justify-center>
                    <v-progress-circular
                            v-show="page_loading"
                            indeterminate
                            color="primary"
                    ></v-progress-circular>
                </v-layout>
            </transition>

            <div class="image-description-wrapper" v-if="img_description_ui.show">
                {{img_description_ui.text}}
            </div>
        </template>

        <v-container v-else fluid fill-height>
            <v-layout align-center justify-center>
                <div class="text-xs-center">
                    <v-icon size="150">error</v-icon>
                    <h2 class="my-3 headline ">{{$t('event.msg_event_not_found')}}</h2>
                </div>
            </v-layout>
        </v-container>

        <app-footer />

    </v-app>
</template>

<script>
    import FormHandling from '~/utils/data/form-handling'
    import {UrlServices} from '~/utils/url-manager'
    import _ from 'lodash'
    import RequestHandler from "~/utils/request-handler";
    import formatter from '~/utils/formatter'
    import VueEasyLightbox from 'vue-easy-lightbox'
    import {FullScreenViewer} from 'iv-viewer';
    import 'iv-viewer/dist/iv-viewer.css';
    import RegistrationStatus from "~/components/enum/registration/RegistrationStatus.ts";
    import MediaType from "~/components/enum/event/MediaType.ts";
    import Utils from "~/utils"
    import OssStyler from "~/utils/images/oss-styler";
    import i18n, {languages} from "~/i18n";
    import AppFooter from "~/components/AppFooter";
    import UploadDialog from "~/components/common/UploadDialog";
    import PaymentMethod from "~/components/enum/registration/PaymentMethod.ts";

    export default {
        name: "index",
        components: {
            UploadDialog,
            VueEasyLightbox,
            AppFooter
        },
        data() {
            return {
                utils: Utils,
                languages: languages,
                img_viewer: null,
                img_description_ui: {
                    show: false,
                    text: ""
                },
                page_loading: true,
                show_event_deleted_layout: false,
                activity_name_list: {},
                event_data: {
                    title: "--",
                    start_timestamp: 0,
                    end_timestamp: 0,
                    event_photos: [],
                    event_attachments: [],
                    contact_select_list: [],
                    registrants: [],
                    maybe_registrants: [],
                    excused_registrants: []
                },
                registration_url: "",
                sign_up_page_url: UrlServices.createAbsoluteUrl({name: 'signup'}),
                form_action: UrlServices.createUrl({name: 'api_public_registration_save'}),
                form: {
                    loading: false,
                },
                form_inputs: {
                    full_name: "",
                    area_code: 852,
                    contact_phone: "",
                    total_guest_number: 1,
                    is_attendee: "1",
                    activity: [],
                    token: this.$route.query.t,
                    attend_status: 1,
                    selected_contact: 0,
                    payment_method: "",
                    payment_receipt_file_id: 0,
                    payment_reference: ""
                },
                guest_details: {
                    guest_name: {
                        0: ""
                    },
                    guest_area_code: {
                        0: "852"
                    },
                    guest_contact_phone: {
                        0: ""
                    },
                },
                form_rules: {
                    required: value => !!value || this.$t('form.field_required'),
                },
                dialog: false,
                registrant_list_dialog: {
                    show: false,
                    show_details: false
                },
                event_attachment_dialog: {
                    show: false
                },
                event_media_dialog: {
                    show: false
                },
                retrieve_registration_dialog: {
                    show: false,
                    area_code: "852",
                    contact_phone: "",
                    loading: false,
                    error: ""
                },
                show_registration_form: false,
                show_cancel_success: false,
                show_registration_success: false,
                show_invitation_declined: false,
                errors: {
                    general: "",
                    full_name: "",
                    contact_phone: "",
                    total_guest_number: "",
                    activity: "",
                    payment_method: "",
                    payment_receipt: ""
                },
                phone_hint_text: "",
                min_phone_search_length: 7,
                phone_searching: false,
                phone_invited: false,
                // phone_accept: false,
                phoneMask: '#'.repeat(50),
                masked_contact_name: "",
                accept: false,
                formHandler: {},
                imgLightBox: {
                    img: '',
                    visible: false,
                    index: 0
                },
                mediaType: MediaType,
                media_list: {
                    filter_type: 0
                },
                selected_contact_info: null,
                show_payment_related: false,
                payment_receipt_file: null,
                hover_image_upload: false,
                uploadPaymentReceiptDialog: {
                    show: false,
                    multiple: false,
                    uploadSuccess: function() {},
                    type: "payment_receipt",
                    maxSizeInMB: 5,
                    postFields: {
                        event_id: null
                    }
                },
                payment_methods: Utils.getEnumValues(PaymentMethod),
                attend_status_index: 0,
                submit_button_text: "",
                show_action_buttons: true,
                show_cancel_btn: false,
                cancel_registration_id: 0
            };
        },
        computed: {
            currentLanguage() {
                return this.$store.state.lang;
            },
            getGuestNumberItems() {

                let items = _.range(1,100);
                if(this.event_data.has_quota_limit){
                    if(this.event_data.remain_quota){
                        let max = this.event_data.remain_quota + 1;
                        if(max >= 100){
                            max = 100;
                        }
                        items = _.range(1, max);
                    } else {
                        items = [];
                    }
                }

                return items;
            },
            getEventCover() {
                return this.event_data.cover_file ? this.event_data.cover_file.absolute_url : '/images/background/bg.jpg';
            },
            getMainContactName() {
                return this.form_inputs.full_name;
            },
            getPhoneHintText() {
                if(this.event_data.allow_invited_contact_only){
                    return this.phone_hint_text;
                }else{
                    return "";
                }
            },
            eventStarted() {
                return false;
                // return getApp.$moment().diff(this.event_data.start_timestamp * 1000) > 0;
            },
            getEventPeriod() {
                let start_time = getApp.$moment(this.event_data.start_timestamp * 1000).format('llll');

                let start_date = getApp.$moment(this.event_data.start_timestamp * 1000).format('LL');
                let end_date = getApp.$moment(this.event_data.end_timestamp * 1000).format('LL');

                let end_time = (start_date === end_date) ? getApp.$moment(this.event_data.end_timestamp * 1000).format('LT') : getApp.$moment(this.event_data.end_timestamp * 1000).format('llll');

                return start_time + ' - ' + end_time;
            },
            isEventFull() {
                let is_full = false;
                if(this.event_data.has_quota_limit && this.event_data.remain_quota == 0){
                    is_full = true;
                }
                return is_full;
            },
            hasActivity() {
                if(this.event_data.activities){
                    return !!this.event_data.activities.length;
                }else{
                    return false;
                }
            },
            showGuestSection() {
                let is_show = this.event_data.allow_guest_to_join;
                if(this.event_data.ask_for_attend){
                    is_show = (is_show && this.form_inputs.attend_status == RegistrationStatus.RESERVED);
                }
                return is_show;
            },
            get_event_location() {
                return this.event_data.location_text ? this.event_data.location_text : this.$t('registration.location_tbc');
            },
            getCurrentLanguage() {
                return this.$store.state.lang;
            }
        },
        methods: {
            registrationSuccess() {
                this.show_registration_form = false;
                this.show_registration_success = true;
                this.updateAttendeeCount();
            },
            invitationDecline() {
                this.show_registration_form = false;
                this.show_invitation_declined = true;
            },
            copyUrl() {
                let me = this;

                // temp fix for copyText library not work in dialog
                const el = document.createElement('textarea')
                el.addEventListener('focusin', e => e.stopPropagation())
                el.value = this.event_data.registration_url
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: me.$t('app.msg_copy_success'),
                    timeout: 3000
                };


                // this.$copyText(this.registration_url).then(function () {
                //     getApp.snackbar = {
                //         show: true,
                //         color: 'green',
                //         text: me.$t('app.msg_copy_success'),
                //         timeout: 3000
                //     };
                // }, function (e) {
                //     console.log('Can not copy');
                //     console.log(e);
                // })
            },
            shareWithWhatsapp() {
                let time_info = this.$t('event.invitation_time_info', {
                    value: this.getEventPeriod
                });
                let location_info = this.$t('event.invitation_location_info', {
                    value: this.event_data.location_text ? this.event_data.location_text : this.$t('registration.location_tbc')
                });

                let message = this.$t('registration.msg_share_event', {
                    'event_name': this.event_data.title,
                    'url': this.event_data.registration_url,
                    'time_info': time_info,
                    'location_info': location_info
                });
                window.open("https://api.whatsapp.com/send?text=" + encodeURI(message))
            },
            shareWithFacebook() {
                window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.event_data.registration_url, null, 'width=640,height=400');
            },
            addToGoogleCalendar() {
                let url = "https://calendar.google.com/calendar/r/eventedit?"
                    + 'text=' + encodeURIComponent(this.event_data.title)
                    + '&dates=' + getApp.$moment(this.event_data.start_timestamp, 'X').format('YYYYMMDD[T]HHmmss')
                    + '/' + getApp.$moment(this.event_data.end_timestamp, 'X').format('YYYYMMDD[T]HHmmss')
                    + (this.event_data.location_text ? '&location=' + this.event_data.location_text : "")
                    + '&details=' + this.$t('registration.msg_view_event_details', {url: this.event_data.registration_url});
                ;
                window.open(url);
            },
            getEventData() {
                let me = this;
                let event_id = this.$route.query.eid;
                let token = this.$route.query.t;
                let show_details = this.$route.query.show_details;

                if(show_details==1){
                    this.registrant_list_dialog.show = true;
                    this.registrant_list_dialog.show_details = true;
                }

                me.page_loading = true;
                if(event_id){
                    RequestHandler.Get(UrlServices.createUrl({name: 'api_public_event_get'}), {
                        event_id: event_id,
                        t: token
                    }, {
                        'success': function(data) {
                            me.event_data = data.event_data;
                            me.show_registration_form = true;
                            me.uploadPaymentReceiptDialog.postFields.event_id = event_id;

                            if(me.event_data.price_per_head > 0){
                                me.show_payment_related = true;
                            }

                            let invitation_contact = data.invitation_contact;
                            if (invitation_contact) {
                                switch (invitation_contact.response) {
                                    case 0:     // pending
                                        formatter.parsePhone(invitation_contact.user_contact);
                                        me.form_inputs.full_name = invitation_contact.user_contact.name;
                                        me.form_inputs.contact_phone = invitation_contact.user_contact.phone;
                                        me.form_inputs.is_attendee = '1';
                                        break;
                                    case 1:     // accepted and registered
                                        me.registrationSuccess();
                                        break;
                                    case -1:    // declined
                                        me.invitationDecline();
                                        break;
                                }
                            }
                            let contact_select_list = data.event_data.contact_select_list;
                            _.each(contact_select_list, function(item){
                                formatter.parsePhone(item);
                                item.phone = me.mask_contact_phone(item.phone);
                                item.search_field = (item.phone.replace(' ', '') + item.name)
                            });
                            me.page_loading = false;

                            // me.retrieveRegistration();
                        },
                        'error': function(data) {
                            if(data.error_type == 'event_deleted'){
                                me.page_loading = false;
                                me.show_event_deleted_layout = true;
                            } else {
                                me.$router.replace({name: 'error_404'});
                            }
                        }
                    });
                } else {
                    this.$router.replace({name: 'error_404'});
                }
            },
            updateAttendeeCount() {
                let me = this;
                let event_id = this.$route.query.eid;
                let token = this.$route.query.t;
                RequestHandler.Get(UrlServices.createUrl({name: 'api_public_event_get'}), {
                    event_id: event_id,
                    t: token
                }, {
                    'success': function(data) {
                        me.event_data = data.event_data;
                    },
                    'error': function() {

                    }
                });
            },
            copy_contact_to_first_guest() {
                if(this.form_inputs.is_attendee){

                    // if(this.event_data.allow_invited_contact_only){
                    //     this.guest_details.guest_name[0] = this.masked_contact_name;
                    // } else {
                        this.guest_details.guest_name[0] = this.form_inputs.full_name;
                    // }

                    this.guest_details.guest_contact_phone[0] = this.form_inputs.contact_phone;
                    this.guest_details.guest_area_code[0] = this.form_inputs.area_code;
                }
            },
            declineInvitation() {
                //TODO ajax to update invitation record
                this.formHandler.pauseSubmit = true;
                let params = {
                    event_id: this.$route.query.eid,
                    t: this.$route.query.t
                };
                let me = this;
                RequestHandler.Post(UrlServices.createUrl({name: 'api_public_invitation_decline'}), params, {
                    'success': function(data) {
                        me.invitationDecline();
                    },
                    'error': function() {

                    }
                });
            },
            searchInvitedContact: _.debounce(function(focus_after_search = true){
                if(!this.selected_contact_info && this.event_data.allow_invited_contact_only && this.form_inputs.contact_phone.length >= this.min_phone_search_length){
                    let me = this;
                    this.phone_hint_text = "";
                    this.masked_contact_name = "";
                    this.phone_searching = true;
                    // this.phone_accept = false;
                    this.phone_invited = false;

                    RequestHandler.Get(UrlServices.createUrl({name: 'api_public_search_invited_contact'}), {
                        event_id: this.$route.query.eid,
                        contact_phone: this.form_inputs.contact_phone
                    }, {
                        'success': function(data){
                            // me.phone_hint_text = me.$t('registration.your_name') + ': ' + data['masked_name'];
                            // me.phone_accept = true;
                            // me.masked_contact_name = data['masked_name'];
                            me.phone_invited = true;
                            me.form_inputs.full_name = data['masked_name'];
                        },
                        'error': function(){
                            me.form_inputs.full_name = "";
                            // me.phone_hint_text = 'Sorry, You are not invited';
                        },
                        'complete': function(){
                            me.phone_searching = false;
                            if(focus_after_search){
                                me.$nextTick(() =>
                                    me.$refs.contact_phone.$el.querySelector('input').focus()
                                );
                            }
                        }
                    });
                }
            }, 1500),
            showImgLightBox(url, text = "") {

                this.img_viewer.show(url);
                if(text){
                    this.img_description_ui.show = true;
                    this.img_description_ui.text = text;
                }

                // window.open(url, '_blank');

                // this.imgLightBox.img = url;
                // this.imgLightBox.visible = true;
            },
            hideImgLightBox() {
                this.imgLightBox.visible = false
            },
            refreshPage() {
                window.location = this.event_data.registration_url;
            },
            shareEvent() {
                if(navigator.share){
                    navigator.share({
                        url: this.event_data.registration_url,
                    })
                }else{
                    this.dialog = true;
                }
            },
            getActivityNamesByIds(ids) {
                if(!Array.isArray(ids)){
                    ids = [ids];
                }
                let me = this;
                let names = [];
                _.each(ids, function(a_id){
                    if(me.activity_name_list[a_id]){
                        names.push(me.activity_name_list[a_id]);
                    }
                });
                return names;
            },
            setAttendStatus(status) {
                let current_scroll_position = $(window).scrollTop();

                let index_ary = {
                    1: 0,
                    7: 1,
                    8: 2
                };

                this.attend_status_index = index_ary[status];

                this.form_inputs.attend_status = status;
                this.$nextTick(() => {
                    $(window).scrollTop(current_scroll_position);
                });
            },
            getRegistrationAttendeeText(registrant) {
                let attendee_names = registrant.attendee_names.slice();

                if(registrant.non_named_guest_count){
                    attendee_names.push(this.$t('registration.num_of_other_guest', {
                        'num': registrant.non_named_guest_count
                    }));
                }
                return attendee_names.join(', ');
            },
            exportRegistrantsList() {
                let me = this;

                // let confirmed_registrant_names = [];
                // let excused_registrant_names = [];
                // let maybe_registrant_names = [];
                //
                // _.each(me.event_data.registrants, function(reg){
                //     let registrants_and_attendee = reg.name;
                //     if(reg.attendee_names.length == 1){
                //         if(reg.name !== reg.attendee_names[0]){
                //             registrants_and_attendee += "\n- " + reg.attendee_names[0];
                //         }
                //     }else if(reg.attendee_names.length > 1){
                //         let attendee_names = [];
                //         _.each(reg.attendee_names, function(name){
                //             attendee_names.push('- ' + name);
                //         });
                //         registrants_and_attendee += "(" + reg.attendee_count + ")";
                //         registrants_and_attendee += "\n" + attendee_names.join("\n");
                //     }
                //     confirmed_registrant_names.push(registrants_and_attendee);
                // });
                //
                // _.each(me.event_data.maybe_registrants,function(reg){
                //     maybe_registrant_names.push(reg.name);
                // });
                //
                // _.each(me.event_data.excused_registrants,function(reg){
                //     excused_registrant_names.push(reg.name);
                // });
                //
                // let confirmed_registrant_content = "";
                // let maybe_registrant_content = "";
                // let excused_registrant_content = "";
                // if(confirmed_registrant_names.length){
                //     confirmed_registrant_content = confirmed_registrant_names.join("\n");
                // }else {
                //     confirmed_registrant_content = "--";
                // }
                // if(maybe_registrant_names.length){
                //     maybe_registrant_content = maybe_registrant_names.join("\n");
                // }else {
                //     maybe_registrant_content = "--";
                // }
                // if(excused_registrant_names.length){
                //     excused_registrant_content = excused_registrant_names.join("\n");
                // }else {
                //     excused_registrant_content = "--";
                // }
                //
                // let message = me.$t('registration.msg_export_registration_list', {
                //     'event_name': me.event_data.title,
                //     'event_location': me.get_event_location,
                //     'event_datetime': getApp.$moment(me.event_data.start_timestamp * 1000).format('LLL'),
                //     'reg_count': me.event_data.registrants.length,
                //     'maybe_reg_count': me.event_data.maybe_registrants.length,
                //     'excused_reg_count': me.event_data.excused_registrants.length,
                //     'attendee_count': me.event_data.attendee_count,
                //     'confirmed_registrant_content': confirmed_registrant_content,
                //     'maybe_registrant_content': maybe_registrant_content,
                //     'excused_registrant_content': excused_registrant_content,
                //     'url': me.registration_url,
                // });

                let message = me.$t('registration.msg_registration_info', {
                    'event_name': me.event_data.title,
                    'event_location': me.get_event_location,
                    'event_datetime': this.getEventPeriod,
                });

                if(me.event_data.display_registrants){
                    message += "\n\n" + me.$t('registration.msg_registration_list_url', {
                        'url': me.event_data.registration_details_url,
                    });
                }

                message += "\n\n" + me.$t('registration.msg_registration_url', {
                    'url': me.event_data.registration_url,
                });


                if(navigator.share){
                    navigator.share({
                        text: message
                    });
                }else{
                    window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message));
                }

            },
            getFileIconByName(filename) {
                return Utils.getIconByFileName(filename);
            },
            downloadFile(url) {
                download(url);
            },
            display_media(media_item) {
                // if(media_item.type == MediaType.NORMAL_IMAGE){
                //     this.showImgLightBox(media_item.file.absolute_url, media_item.caption);
                // } else if(media_item.type == MediaType.VR_IMAGE){
                    this.openMediaVr(media_item);
                // }
            },
            getThumbnailUrl(url) {
                return OssStyler.getThumbnailResUrl(url);
            },
            openMediaVr(media) {
                let url = UrlServices.createAbsoluteUrl({name: 'vr'}) + '?media_id=' + media['encrypted_id'];
                window.open(url, '_blank');
            },
            changeLanguage(language) {
                this.$store.dispatch('setLang', language).then(() => {
                    this.$router.replace({params: {'lang': language}, query: this.$route.query});
                });
            },
            mask_contact_phone(phone_number) {
                let string_len = phone_number.length;
                let string_ary = phone_number.split("");
                let output_component = [];
                _.each(string_ary, function(char, index){
                    if(index === 0 || index === (string_len-1)){
                        output_component.push(char);
                    } else {
                        output_component.push("*");
                    }
                });
                return output_component.join("");
            },
            show_upload_receipt_dialog() {
                let me = this;
                this.uploadPaymentReceiptDialog.show = true;
                this.uploadPaymentReceiptDialog.uploadSuccess = function(data) {
                    me.uploadPaymentReceiptDialog.show = false;
                    me.form_inputs.payment_receipt_file_id = data.result.id;
                    me.payment_receipt_file = data.result;
                }
            },
            remove_payment_receipt_file() {
                this.payment_receipt_file = null;
                this.form_inputs.payment_receipt_file_id = null;
            },
            retrieveRegistration() {
                let me = this;
                let event_id = this.$route.query.eid;

                me.retrieve_registration_dialog.loading = true;
                me.retrieve_registration_dialog.error = "";

                RequestHandler.Get(UrlServices.createUrl({name: 'api_public_registration_retrieve'}), {
                    event_id: event_id,
                    area_code: me.retrieve_registration_dialog.area_code,
                    contact_phone: me.retrieve_registration_dialog.contact_phone
                }, {
                    'success': function(json_data) {

                        let data = json_data.registration_data;
                        let error_msg = json_data.error_msg;

                        me.cancel_registration_id = data.id;

                        me.setAttendStatus(data.status);

                        let contact = data.contact;
                        formatter.parsePhone(contact);

                        me.form_inputs.contact_phone = contact.phone.replace(' ', '');
                        me.form_inputs.area_code = contact.areaCode.replace('+', '');
                        if(me.event_data.allow_invited_contact_only){
                            me.searchInvitedContact(false);
                        }else{
                            me.form_inputs.full_name = contact.name;
                        }

                        if(data.status == RegistrationStatus.RESERVED){
                            let attendees = data.attendees;
                            _.each(attendees, (attendee) => {
                                formatter.parsePhone(attendee);
                            });

                            me.form_inputs.total_guest_number = parseInt(data.attendee_count);
                            if(
                                attendees[0].areaCode == contact.areaCode
                                &&
                                attendees[0].phone == contact.phone
                                &&
                                attendees[0].name == contact.name
                            ){
                                me.form_inputs.is_attendee = "1";
                            } else {
                                me.form_inputs.is_attendee = null;
                            }

                            me.$nextTick(() => {
                                _.each(attendees, (attendee, i) => {
                                    me.guest_details.guest_area_code[i] = attendee.areaCode.replace('+', '');
                                    me.guest_details.guest_contact_phone[i] = attendee.phone.replace(' ', '');
                                    me.guest_details.guest_name[i] = attendee.name;
                                });
                            });

                            me.form_inputs.payment_method = data.submitted_payment_method;
                            me.form_inputs.payment_reference = data.submitted_payment_ref;
                            me.form_inputs.custom_field_value = data.custom_field_value;
                            me.form_inputs.custom_field_value_2 = data.custom_field_value_2;
                            me.form_inputs.custom_field_value_3 = data.custom_field_value_3;
                            if(me.event_data.activity_multiple){
                                me.form_inputs.activity = data.activities;
                            } else {
                                if(data.activities.length){
                                    me.form_inputs.activity = data.activities[0];
                                } else {
                                    me.form_inputs.activity = [];
                                }

                            }

                            // restore payment related data
                            if(data.payment_receipt_file.length){
                                let payment_receipt_file = data.payment_receipt_file[0];
                                me.payment_receipt_file = payment_receipt_file;
                                me.form_inputs.payment_receipt_file_id = payment_receipt_file.id;
                            }
                        }

                        me.closeRetrieveRegistrationDialog();

                        if(error_msg){
                            me.show_action_buttons = false;
                        } else {
                            me.show_action_buttons = true;
                            me.show_cancel_btn = true;
                        }

                        me.errors.general = error_msg;
                        me.submit_button_text = me.$t('action.update')

                        // me.form_inputs.contact_phone = data.
                    },
                    'error': function(data) {
                        me.retrieve_registration_dialog.error = me.$t('general.no_record_found');
                        me.submit_button_text = me.$t('action.submit')
                        me.show_action_buttons = true;
                        me.show_cancel_btn = false;
                    },
                    'complete': function() {
                        me.retrieve_registration_dialog.loading = false;
                    }
                });
            },
            closeRetrieveRegistrationDialog() {
                this.retrieve_registration_dialog.show = false;
                this.retrieve_registration_dialog.area_code = "852";
                this.retrieve_registration_dialog.contact_phone = "";
                this.retrieve_registration_dialog.error = "";
            },
            cancelRegistration() {
                let me = this;
                let event_id = this.$route.query.eid;

                this.$root.$confirm(
                    this.$t('event.cancel_registration'),
                    this.$t('event.cancel_registration_msg'))
                    .then((confirm) => {
                        if(confirm){
                            RequestHandler.Post(UrlServices.createUrl({name: 'api_public_registration_cancel'}), {
                                event_id: event_id,
                                registration_id: me.cancel_registration_id,
                            }, {
                                'success': function(json_data) {
                                    me.show_registration_form = false;
                                    me.show_cancel_success = true;
                                    me.updateAttendeeCount();
                                },
                                'error': function(data) {

                                },
                                'complete': function() {

                                }
                            });
                        }
                    });
            }
        },
        mounted: function() {
            let me = this;
            this.getEventData();
            _.each(me.getGuestNumberItems, function(number){
                me.errors['guest_name_' + number] = '';
                me.errors['guest_contact_phone_' + number] = '';
            });
            this.formHandler = new FormHandling(this, "registration_form", this.form);
            this.img_viewer = new FullScreenViewer();
            $(document).on('click', '.event-info-text img', function(){
                me.showImgLightBox($(this).attr('src'));
            });

            $(document).on('click', '.iv-fullscreen-close', function() {
                me.img_description_ui.show = false;
                me.img_description_ui.text = "";
            });
            me.submit_button_text = this.$t('action.submit')
        },
        watch: {
            event_data: function() {
                this.registration_url = UrlServices.createAbsoluteUrl({name: 'registration'}) + '?eid=' + this.event_data.encrypted_id;

                let activity_name_list = {};
                if(this.event_data.activities){
                    _.each(this.event_data.activities, function(activity) {
                        activity_name_list[activity.id] = activity.name;
                    });
                }
                this.activity_name_list = activity_name_list;
            },
            form_inputs: {
                handler(){
                    this.copy_contact_to_first_guest();
                },
                deep: true
            },
            masked_contact_name: function(){
                this.copy_contact_to_first_guest();
            },
            'form_inputs.is_attendee': function(val){
                if(!val){
                    // console.log("empty guest");
                    this.guest_details.guest_name[0] = "";
                    this.guest_details.guest_contact_phone[0] = "";
                }
            },
            'form_inputs.total_guest_number': function(val) {
                let me = this;
                _.each(_.range(val), function(num, index) {
                    if(me.guest_details.guest_area_code[index]=="" || me.guest_details.guest_area_code[index] == undefined){
                        me.guest_details.guest_area_code[index] = "852";
                    }
                });
            },
            'form_inputs.attend_status': function() {
                // console.dir('change Status');
            },
            'form_inputs.payment_method': function(val) {
                if(val == PaymentMethod.CASH){
                    if(this.form_inputs.payment_reference == ""){
                        this.form_inputs.payment_reference = "Cash";
                    }
                } else {
                    if(this.form_inputs.payment_reference == "Cash"){
                        this.form_inputs.payment_reference = "";
                    }
                }
            },
            selected_contact_info: function(obj) {
                if(obj){
                    this.form_inputs.area_code = parseInt(obj.areaCode);
                    this.form_inputs.contact_phone = obj.phone;
                    this.form_inputs.full_name = obj.name;
                    this.form_inputs.selected_contact = obj.id;
                    this.phoneMask = "";
                }else{
                    this.form_inputs.area_code = "852";
                    this.form_inputs.contact_phone = "";
                    this.form_inputs.full_name = "";
                    this.form_inputs.selected_contact = 0;
                    this.phoneMask = '#'.repeat(50);
                }
            }
        },
    }
</script>

<style scoped>
    .event-info-text {
        overflow: visible;
        white-space: pre-line;
    }
    .notification-header {
        font-size: 26px;
    }
    .attendee-wrapper, .activity-wrapper {
        font-size: 0.8em;
        color: #999;
    }
</style>

<style>
    .full-height .v-list__tile {
        height: 100%;
    }

    #event_background.v-parallax {
        height: 100%;
    }

    #event_background.v-parallax .v-parallax__image-container img {
        -webkit-filter: blur(15px);
        -moz-filter: blur(15px);
        -o-filter: blur(15px);
        -ms-filter: blur(15px);
        filter: blur(15px);
    }

    .event-info-text img {
        max-width: 100%;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }

    .event-info-text-icon {
        position: relative;
        top: 2px;
        cursor: pointer;
    }

    .event-description-wrapper {
        max-height: 300px;
        justify-content: normal;
        overflow-y: auto;
    }

    .event-stat-span:not(:last-child){
        border-right: 1px solid #AAA;
        padding-right: 10px;
        margin-right: 5px;
    }

    .event-info-text p {
        margin-top: 8px;
        margin-bottom: 8px;
        white-space: normal;
        line-break: auto;
    }

    .event-time-text, .address-text {
        margin-top: 12px;
        margin-bottom: 12px;
        height: auto;
        white-space: inherit;
    }

    .text-overflow, .text-overflow div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .payment-status-text {
        color: #9e9e9e;
        font-size: 12px;
    }

    table.details-table {
        margin: 0 auto;
    }

    .details-table th{
        text-align: left;
        padding-right: 15px;
    }
    .details-table td{
        text-align: left;
    }

    .sp-badge .v-badge__badge {
        border-radius: 8px;
        min-width: 22px;
        width: auto;
        padding: 0 5px;
    }

    .iv-fullscreen-close {
        background-color: rgba(0,0,0,0.5);
    }

    .dialog-sep {
        margin: 10px 0;
    }

    .content-scrollable {
        overflow-x: auto;
    }

    .event-image-grid {
        border: 1px solid #ccc!important;
        cursor: pointer;
    }

    .image-description-wrapper {
        position: fixed;
        z-index: 10000;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(0,0,0,0.3);
        color: #FFF;
        padding: 5px;
        border-radius: 5px;
        font-size: 15px;
    }

    .download-button {
        text-decoration: none;
    }

    .cover-copy-right-wp {
        position: absolute;
        bottom: 5px;
        right: 5px;
        background-color: rgba(0,0,0,0.5);
        color: #FFF;
        padding: 0 5px;
        border-radius: 3px;
    }

    .activity-checkbox-item {
        display: inline-block;
        padding-right: 10px;
    }

    .registrants-list-item > .v-list__tile {
        height: auto;
        padding: 10px 10px;
    }

    .lang-btn {
        min-width: auto;
    }

    @media screen and (max-width: 900px) {
        #event_background .v-parallax__content {
            padding: 0;
        }

        #event_background .container {
            padding: 8px;
        }
    }

</style>